import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const nav = useNavigate();

    return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
            <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                Erreur
            </p>
            <h1 className="mt-2 font-crimson text-[96px] font-bold leading-none text-leadrs-text">
                404
            </h1>
            <p className="mt-4 font-crimson text-2xl font-semibold text-leadrs-text">
                Page introuvable
            </p>
            <p className="mt-3 max-w-sm font-geist text-sm text-leadrs-text-soft">
                Cette page n'existe pas ou a été déplacée. Vérifiez l'URL ou retournez à l'accueil.
            </p>
            <button
                className="mt-8 rounded-lg bg-leadrs-brand px-6 py-2.5 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                onClick={() => nav('/dashboard')}
            >
                Retour au tableau de bord
            </button>
        </div>
    );
};

export default NotFound;
